/* --------------------------------------------------------------------------
   Quick view — desktop drawer / phone bottom sheet (templates/product.quick.liquid)
   -------------------------------------------------------------------------- */
var TCPQuickView = (function () {
  var SIZE_NAMES = { 'XS': 'Extra Small', 'S': 'Small', 'M': 'Medium', 'L': 'Large', 'XL': 'Extra Large', 'S/M': 'Small/Medium', 'M/L': 'Medium/Large' };
  var LOW_STOCK = 5;
  var panel, overlay, swiper = null, lastFocus = null, currentUrl = null, req = 0;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function sizeName(v) { v = (v || '').trim(); return SIZE_NAMES[v.toUpperCase()] || v; }
  function isPhone() { return window.matchMedia('(max-width: 767px)').matches; }

  function ensure() {
    panel = document.getElementById('tcp-qv'); overlay = $('.tcp-qv-overlay');
    return !!(panel && overlay);
  }

  function open(url, opts) {
    if (!ensure()) return;
    opts = opts || {};
    lastFocus = document.activeElement;
    currentUrl = url;
    var mine = ++req;
    panel.hidden = false;
    if (!panel.classList.contains('open')) {
      panel.innerHTML = '<div class="tcp-qv__spinner"><i></i></div>';
      void panel.offsetWidth; // flush display:none → block so the slide-in transition runs (rAF is paused in background tabs)
      panel.classList.add('open'); overlay.classList.add('open'); document.documentElement.classList.add('tcp-qv-open');
      if (TCPCart && TCPCart.close) TCPCart.close();
    } else {
      panel.classList.add('is-loading');
    }
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (mine !== req) return;
        panel.innerHTML = html;
        panel.classList.remove('is-loading');
        scopeStyles();
        init(new URL(url, location.origin).searchParams.get('color'));
        track();
      })
      .catch(function () {
        if (mine !== req) return;
        // Fall back to the product page rather than leaving a broken panel.
        var full = opts.fullUrl || url.replace(/[?&]view=quick/, '');
        location.href = full;
      });
  }

  function close() {
    if (!panel) return;
    if (swiper) { try { swiper.destroy(true, true); } catch (e) {} swiper = null; }
    panel.classList.remove('open', 'dragging'); panel.style.transform = '';
    overlay.classList.remove('open');
    document.documentElement.classList.remove('tcp-qv-open');
    setTimeout(function () { if (!panel.classList.contains('open')) { panel.hidden = true; panel.innerHTML = ''; } }, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* product-color-options ships <style> blocks with global selectors; keep them inside the panel. */
  function scopeStyles() {
    $$('style', panel).forEach(function (st) {
      st.textContent = st.textContent.replace(/(^|\})([^{}]+)\{/g, function (m, a, sel) {
        return a + sel.split(',').map(function (x) { x = x.trim(); return x ? '#tcp-qv ' + x : x; }).join(',') + '{';
      });
    });
  }

  function init(color) {
    var inner = $('.tcp-qv__inner', panel); if (!inner) return;
    var hasColor = inner.getAttribute('data-has-color') === 'true';
    var sizes = $$('[data-qv-size]', inner);
    var slides = $$('.swiper-slide', inner);

    // Pick the colorway: requested, else the first one that has a slide.
    if (hasColor) {
      var colors = slides.map(function (s) { return s.getAttribute('data-color'); }).filter(function (c, i, a) { return c && a.indexOf(c) === i; });
      if (!color || colors.indexOf(color) < 0) color = colors[0] || '';
      slides.forEach(function (s) { if (s.getAttribute('data-color') !== color) s.remove(); });
      sizes.forEach(function (b) { if (b.getAttribute('data-color') !== color) b.hidden = true; });
    }
    inner.setAttribute('data-color-current', hasColor ? (color || '') : '');

    // Slider
    var sliderEl = $('[data-qv-slider]', inner);
    var count = $$('.swiper-slide', sliderEl).length;
    if (window.Swiper && sliderEl) {
      swiper = new Swiper(sliderEl, {
        slidesPerView: 1, spaceBetween: 0, loop: count > 1, watchOverflow: true,
        pagination: { el: $('.swiper-pagination', sliderEl), clickable: true },
        navigation: { nextEl: $('.tcp-qv__arrow--next', sliderEl), prevEl: $('.tcp-qv__arrow--prev', sliderEl) }
      });
    }
    if (count < 2) $$('.tcp-qv__arrow, .swiper-pagination', sliderEl).forEach(function (el) { el.hidden = true; });

    // Sizes
    var label = $('[data-qv-size-label]', inner), variantInput = $('[data-qv-variant]', inner), addBtn = $('[data-qv-add]', inner);
    var stock = $('[data-qv-stock]', inner), bo = $('[data-qv-backorder]', inner), boProp = $('[data-qv-backorder-prop]', inner);
    function select(btn) {
      sizes.forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
      variantInput.value = btn.getAttribute('data-variant-id');
      label.textContent = sizeName(btn.getAttribute('data-size')); label.classList.remove('is-empty');
      var qty = parseInt(btn.getAttribute('data-qty'), 10), isBo = btn.getAttribute('data-backorder') === 'true';
      if (stock) { if (!isBo && qty > 0 && qty <= LOW_STOCK) { stock.textContent = 'Low stock — ' + qty + ' left'; stock.hidden = false; } else { stock.hidden = true; } }
      if (bo) bo.hidden = !isBo;
      if (boProp) boProp.disabled = !isBo;
      addBtn.disabled = false; addBtn.textContent = isBo ? 'Pre-Order Now' : 'Add to Bag';
      try { setCookie('default_size', handleize(btn.getAttribute('data-size')), 30); } catch (e) {}
    }
    sizes.forEach(function (b) { b.addEventListener('click', function () { if (!b.disabled) select(b); }); });
    // Remember the shopper's usual size if it's available here (same cookie the PDP uses).
    var want = getCookie('default_size');
    if (want) {
      var hit = sizes.filter(function (b) { return !b.hidden && !b.disabled && handleize(b.getAttribute('data-size')) === want; })[0];
      if (hit) select(hit);
    }

    // Gift toggle
    var gift = $('[data-qv-gift]', inner), note = $('[data-qv-gift-note]', inner);
    if (gift) {
      gift.addEventListener('change', function () {
        var on = gift.checked; var box = gift.closest('.tcp-qv__gift'); box.classList.toggle('is-on', on);
        note.hidden = !on; var ta = $('textarea', note); ta.disabled = !on; if (on) ta.focus();
      });
    }

    // Add to bag → close, then let the cart drawer take over.
    var form = $('#tcp-qv-form', inner);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput.value) { label.textContent = 'Please pick a size'; label.classList.add('is-empty'); return; }
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      var fd = form; // FormData reads form="tcp-qv-form" controls too
      close();
      TCPCart.addFromForm(fd);
      track('add_to_cart_quick_view');
    });

    // Swatches inside the panel swap the product in place instead of navigating.
    $$('.color-swatch', inner).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var href = a.getAttribute('href'); if (!href) return;
        open(href + (href.indexOf('?') > -1 ? '&' : '?') + 'view=quick', { fullUrl: href });
      });
    });

    $$('[data-qv-close]', inner).forEach(function (b) { b.addEventListener('click', close); });
    bindDrag(inner);
    var first = $('.tcp-qv__close', inner); if (first) first.focus({ preventScroll: true });
  }

  /* Phone: drag the handle / header down to dismiss */
  function bindDrag(inner) {
    var handles = [$('.tcp-qv__grab', inner), $('.tcp-qv__head', inner)].filter(Boolean);
    var startY = null;
    function down(e) { if (!isPhone() || e.target.closest('button')) return; startY = e.clientY; panel.classList.add('dragging'); }
    function move(e) { if (startY === null) return; var d = Math.max(0, e.clientY - startY); panel.style.transform = 'translateY(' + d + 'px)'; }
    function up(e) { if (startY === null) return; var d = e.clientY - startY; startY = null; panel.classList.remove('dragging'); if (d > 120) close(); else panel.style.transform = ''; }
    handles.forEach(function (h) { h.addEventListener('pointerdown', down); });
    document.addEventListener('pointermove', move); document.addEventListener('pointerup', up); document.addEventListener('pointercancel', up);
  }

  function track(name) {
    var inner = $('.tcp-qv__inner', panel); if (!inner) return;
    var item = { item_id: inner.getAttribute('data-product-id'), item_name: inner.getAttribute('data-title'), price: parseFloat(inner.getAttribute('data-price')) || undefined };
    var ev = name || 'quick_view';
    try { if (typeof gtag === 'function') gtag('event', ev, { items: [item] }); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: ev, ecommerce: { items: [item] } }); } catch (e) {}
    // Recently viewed (recently-viewed.js listens): a quick view counts as a view.
    if (ev === 'quick_view') {
      try { document.dispatchEvent(new CustomEvent('tcp:product:viewed', { detail: { handle: inner.getAttribute('data-handle'), color: inner.getAttribute('data-color-current') || '' } })); } catch (e) {}
    }
  }

  function bind() {
    if (!ensure()) return;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-quick-view]');
      if (t) { e.preventDefault(); e.stopPropagation(); open(t.getAttribute('data-quick-view'), { fullUrl: t.getAttribute('data-product-url') }); return; }
      if (e.target === overlay) close();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('open')) close(); });
    // Switch between drawer and sheet cleanly if the window is resized across the breakpoint.
    var wasPhone = isPhone();
    window.addEventListener('resize', function () { var now = isPhone(); if (now !== wasPhone) { wasPhone = now; panel.style.transform = ''; } });
  }

  return { open: open, close: close, bind: bind };
})();

window.addEventListener('load', function () { if (window.TCPCart) TCPQuickView.bind(); });
